const KEY = 'forxa.permissionPreview.v1';
const HASH_PREFIX = '#permission-preview=';

function loadToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    if (window.location.hash.startsWith(HASH_PREFIX)) {
      const token = decodeURIComponent(window.location.hash.slice(HASH_PREFIX.length));
      if (!/^[A-Za-z0-9_.-]+$/.test(token) || token.length > 12000) return 'invalid';
      sessionStorage.setItem(KEY, token);
      // Fragment is never sent to the server; remove it from the visible URL.
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      return token;
    }
    return sessionStorage.getItem(KEY);
  } catch { return window.location.hash.startsWith(HASH_PREFIX) ? 'invalid' : null; }
}

let previewToken = loadToken();
export function getPermissionPreviewToken() { return previewToken; }
export function isPermissionPreview() { return Boolean(previewToken); }
export function closePermissionPreview() {
  // Never call logout or rotate cookies; the administrator's other tab stays signed in.
  window.close();
  // Browsers may refuse close for a restored tab; return to the manager's session.
  previewToken = null;
  sessionStorage.removeItem(KEY);
  window.location.replace('/people');
}

export function permissionPreviewUrl(token: string) {
  return `${window.location.origin}/#permission-preview=${encodeURIComponent(token)}`;
}
